module.exports = __webpack_public_path__ + "static/projekt_indywidualny_e16-03e78cc65a0ab4d6184d016488505203.jpg";